import { useCallback, useState } from "react";
import { LightboxSlide } from "../components/common/ImageLightbox";

/**
 * Open/index/slides state for ImageLightbox. Spread `lightboxProps` onto the
 * component and call `openAt` from a thumbnail's click handler.
 *
 * Closing leaves the slides in place: the lightbox fades out, and emptying
 * them here would blank the frame mid-animation.
 */
export const useImageLightbox = () => {
  const [slides, setSlides] = useState<LightboxSlide[]>([]);
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const openAt = useCallback(
    (nextSlides: LightboxSlide[], nextIndex: number) => {
      setSlides(nextSlides);
      setIndex(nextIndex);
      setOpen(true);
    },
    []
  );

  const close = useCallback(() => setOpen(false), []);

  return {
    openAt,
    close,
    lightboxProps: { open, index, slides, onClose: close },
  };
};
